import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_BOOSTER } from './router';

menuRegistry.registerMenu([
    {
        parent: 'Puzzle',
        key: 'BoosterItem',
        name: 'Booster Item',
        icon: 'fas fa-syringe',
        route: { name: ROUTE_NAME_BOOSTER.INDEX }
    }
]);

export default registerRouteForModule(router);
